import React, { Suspense, lazy } from 'react';

const ShadowWizard = lazy(() =>
  import(/* webpackChunkName: "ShadowWizard" */ '../../components/ShadowWizard')
);

const LoadingComponent = () => (
  <div className="bc-white-50 rounded ba b--ddd shadow1 h9 d-flex jc-center align-center mt5">
    <div className="c-black-50">...</div>
  </div>
);

export default function ShadowWizardComponent({...props}) {
  return (
    <Suspense fallback={<LoadingComponent />}>
      <ShadowWizard {...props} />
    </Suspense>
  );
}
